(() => {
  if (window.BambuSearch) return;

  const fields = ["title", "product_type", "variants.sku"];
  const cleanTerm = (value) => String(value || "").replace(/["\\]/g, " ").replace(/\s+/g, " ").trim();
  const displayTerm = (value) => {
    const match = String(value || "").match(/^\(title:"([^"]*)" OR product_type:/);
    return cleanTerm(match ? match[1] : value);
  };
  const buildQuery = (value) => {
    const term = displayTerm(value);
    if (!term) return "";
    let words = term.replace(/bambu\s+lab/ig, "").trim().split(/\s+/).filter(Boolean);
    if (!words.length) words = term.split(/\s+/);
    const phrases = [...new Set([term, ...words])];
    return phrases.map((phrase) => `(${fields.map((field) => `${field}:"${phrase}"`).join(" OR ")})`).join(" OR ");
  };
  const isSearchURL = (url) => url.origin === location.origin && /(?:^|\/)search\/?$/.test(url.pathname);
  const normalizeURL = (value) => {
    const url = new URL(value, location.href);
    if (!isSearchURL(url)) return url;
    const query = url.searchParams.get("q");
    if (query !== null) url.searchParams.set("q", buildQuery(query));
    url.searchParams.set("type", "product");
    url.searchParams.delete("query_length");
    url.searchParams.delete("predictive-search-types");
    if (!url.searchParams.get("filter.p.product_type")) url.searchParams.delete("filter.p.product_type");
    return url;
  };
  window.BambuSearch = { buildQuery, displayTerm, normalizeURL, isSearchURL };

  document.addEventListener("submit", (event) => {
    if (event.defaultPrevented || !(event.target instanceof HTMLFormElement)) return;
    const form = event.target;
    const url = new URL(form.action, location.href);
    if (!isSearchURL(url) || !form.querySelector('[name="q"]')) return;
    event.preventDefault();
    url.search = new URLSearchParams(new FormData(form)).toString();
    location.assign(normalizeURL(url).href);
  });

  document.addEventListener("click", (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest("a[href]");
    if (!link || link.hasAttribute("download") || (link.target && link.target !== "_self")) return;
    const url = new URL(link.href, location.href);
    if (!isSearchURL(url) || !url.searchParams.get("q")) return;
    if (link.closest("collection-modes") && isSearchURL(new URL(location.href))) {
      const current = new URL(location.href);
      current.searchParams.set("view", url.searchParams.get("view") || "");
      current.searchParams.delete("page");
      event.preventDefault();
      location.assign(normalizeURL(current).href);
      return;
    }
    const normalized = normalizeURL(url);
    if (normalized.href === url.href) return;
    event.preventDefault();
    location.assign(normalized.href);
  });

  const normalizeCurrentSearch = () => {
    const currentURL = new URL(location.href);
    if (isSearchURL(currentURL) && currentURL.searchParams.get("q")) {
      const normalized = normalizeURL(currentURL);
      if (normalized.href !== currentURL.href) {
        location.replace(normalized.href);
      } else if (currentURL.searchParams.get("q") !== displayTerm(currentURL.searchParams.get("q"))) {
        currentURL.searchParams.set("q", displayTerm(currentURL.searchParams.get("q")));
        history.replaceState(history.state, "", currentURL.href);
      }
    }
  };
  // Let the other deferred theme scripts finish before an initial redirect.
  if (document.readyState === "complete") normalizeCurrentSearch();
  else document.addEventListener("DOMContentLoaded", normalizeCurrentSearch, { once: true });
})();
